module.exports = __webpack_public_path__ + "img/shipblu-logo.875b3022.svg";